export default "__VITE_ASSET__DlQN0177__"